import React from "react";
import {FormSectionElements} from "src/entities/formTemplateDataType";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import styled from "styled-components";
import Utils from "../../utilities/Utils";
import {LiveValidationErrMsg} from "../live-validation-errMsg/LiveValidationErrMsg";
import validator from 'validator'
import ReCaptchaButton from "../captcha/captcha-button";
import ReCaptchaV3 from "../captcha/CaptchComponent";

interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  isEng: boolean;
  callback;
  disabled?:boolean;
  enableRecaptcha?: boolean;
}

interface State {
  buttonClicked:boolean;
  val:string;
}

const Container = styled.div`
  display: flex;
  flex-direction: row; 
  gap: 10px;
  flex-wrap: wrap;

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

export const EmailContainer = styled.div`
  width: 400px;
  margin-right:10px;
  @media (max-width: 767px) {
    width: 100%;
  }
`;

export const ButtonContainer = styled.div`
    width: 80px;
    @media (max-width: 767px) {
        width: 100% !important;
    }
`;

export class EmailButtonComponent extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state={
      buttonClicked:false,
      val:''
    }
  }

  render() {
    let field = this.props.field;
    let controlArray = [];
    let title = this.props.title;
    const isDisabled:boolean = this.props.disabled ?? false

    controlArray.push(
      <div key={"emailbutton_" + { title }}>
        <div>
          {title}
          {this.props.field.ENUDescription && <p>{this.props.isEng ? field.ENUDescription : field.FRADescription}</p>}
        </div>
        <div>
           <LiveValidationErrMsg
                field={field}
                isEng={this.props.isEng}
                key={"LiveValidationErrMsg_email_button"} />

        </div>
          <Container>
              <div>
                  <EmailContainer>
                      <input
                          className="ontario-input" value={field.Value} disabled={isDisabled} onChange={(e) => {
                          field.Value = e.target.value
                          this.setState({val: field.Value})
                          if (Utils.isNotNullOrEmpty(field.Value)) {
                              this.handleEmailValidation(field);
                          }
                      }}
                      />
                  </EmailContainer>
              </div>

              <div>
                  <ButtonContainer>
                      {!this.props?.enableRecaptcha || isDisabled ?
                          (
                              <button
                                  className="ontario-button ontario-button--secondary"
                                  disabled={isDisabled}
                                  onClick={() => this.handleSendButtonClick(field)}
                              >
                                  <svg className="ontario-icon" aria-hidden="true" focusable="false" viewBox="0 0 24 24"
                                       preserveAspectRatio="xMidYMid meet">
                                      <use href="#ontario-icon-email"></use>
                                  </svg>
                                  {this.props.isEng ? "Send" : "Envoyer"}
                              </button>
                          )
                          : (
                              <ReCaptchaV3
                                  lang={this.props.isEng ? 'en' : 'fr'}>
                                  <ReCaptchaButton
                                      key={"recaptchbutton"}
                                      title={title}
                                      action={field?.Recaptcha?.action || 'sendEmailAction'}
                                      cssClass={'ontario-button ontario-button--secondary'}
                                      buttonHandler={(token) => this.handleSendButtonClick(field, token)}
                                  >
                                      <svg className="ontario-icon" aria-hidden="true" focusable="false"
                                           viewBox="0 0 24 24"
                                           preserveAspectRatio="xMidYMid meet">
                                          <use href="#ontario-icon-email"></use>
                                      </svg>
                                      {this.props.isEng ? "Send" : "Envoyer"}
                                  </ReCaptchaButton>
                              </ReCaptchaV3>
                          )
                      }
                  </ButtonContainer>
              </div>

          </Container>
      </div>
    );

    return controlArray;
  }

    private handleSendButtonClick(field: FormSectionElements, token?: string) {
        field.Value = this.state.val;

        this.handleEmailValidation(field);
        if (!field?.Valid) {
            this.forceUpdate();
            return null;
        }

        if (field.Script) {
            FormValidationUtils.runJavascript(field);
        }

        this.setState({buttonClicked: true})
        this.props.callback(field, token);
    }

    private handleEmailValidation(field: FormSectionElements) {
        field.Valid = validator.isEmail(field.Value);
        field.Touched = true;
        field.IsEmpty = false;
        field.ErrorMessage = 'A valid email address is required.';
        field.ErrorMessageFRA = "Une adresse de courriel valide est obligatoire.";
    }
}

